import React from 'react';
import { makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 6px',
    borderRadius: 6,
    color: theme.palette.primary.main,
    fontFamily:
      "SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
    fontSize: 13,
    fontWeight: 600,
    backgroundColor:
      theme.palette.type === 'dark'
        ? alpha(theme.palette.primary.main, 0.18)
        : alpha(theme.palette.primary.main, 0.08)
  }
}));

function CodeInline(props) {
  const classes = useStyles();

  return (
    <code
      className={classes.root}
      {...props}
    />
  );
}

export default CodeInline;
